export const COGO_COLLAB_SCHEMA_VERSION =
  "cogo.studio-preview-collaboration.v1" as const;

export const COGO_COLLAB_LEDGER_SCHEMA_VERSION =
  "cogo.studio-preview-collaboration-ledger.v1" as const;

export type CogoActorKind = "user" | "agent" | "system";

export interface CogoCollabActor {
  id: string;
  kind: CogoActorKind;
  label: string;
}

export interface CogoPreviewAnchor {
  appId?: string;
  pageId?: string;
  blockId?: string;
  blockName?: string;
  blockType?: string;
  propertyKey?: string;
  previewElementId?: string;
  cogoJsonPath?: string;
  label: string;
}

export type CogoJsonPatchOpKind =
  | "add"
  | "replace"
  | "remove"
  | "move"
  | "copy"
  | "test";

export interface CogoJsonPatchOp {
  op: CogoJsonPatchOpKind;
  path: string;
  value?: unknown;
  from?: string;
}

export type CogoCollabEffectType =
  | "preview-anchor"
  | "proof-link"
  | "actionflow-trace"
  | "visual-diff"
  | "user-comment"
  | "agent-rationale";

export interface CogoCollabEffect {
  type: CogoCollabEffectType;
  payload: unknown;
}

export type CogoCollabTransactionStatus =
  | "draft"
  | "proposed"
  | "accepted"
  | "rejected"
  | "conflicted"
  | "applied";

export interface CogoCollabTransaction {
  schemaVersion: typeof COGO_COLLAB_SCHEMA_VERSION;
  id: string;
  versionBefore: number;
  versionAfter: number;
  actor: CogoCollabActor;
  target: CogoPreviewAnchor;
  changes: CogoJsonPatchOp[];
  effects: CogoCollabEffect[];
  status: CogoCollabTransactionStatus;
  createdAt: string;
  updatedAt?: string;
}

export type CogoCollabConflictReason =
  | "same-json-path"
  | "same-block-property"
  | "deleted-target"
  | "stale-preview-anchor"
  | "failed-validation";

export type CogoCollabConflictResolution =
  | "keep-local"
  | "accept-incoming"
  | "manual-review";

export interface CogoCollabConflict {
  id: string;
  localId: string;
  incomingId: string;
  reason: CogoCollabConflictReason;
  message: string;
  resolution?: CogoCollabConflictResolution;
  createdAt: string;
}

export interface CogoHistoryEvent {
  id: string;
  transactionIds: string[];
  actor: CogoCollabActor;
  userEvent: string;
  createdAt: string;
}

export interface CogoHistoryState {
  done: CogoHistoryEvent[];
  undone: CogoHistoryEvent[];
}

export interface CogoCollabLedger {
  schemaVersion: typeof COGO_COLLAB_LEDGER_SCHEMA_VERSION;
  syncedVersion: number;
  localVersion: number;
  unconfirmedTransactionIds: string[];
  transactions: CogoCollabTransaction[];
  conflicts: CogoCollabConflict[];
  history: CogoHistoryState;
  updatedAt: string;
}

export const COGO_USER_ACTOR: CogoCollabActor = {
  id: "user",
  kind: "user",
  label: "User",
};
